import { Component, inject, Input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Meldung } from '@app/shared/classes/meldung';
import { Notiz, NotizKantonCmd } from '@app/shared/classes/notiz';
import { BackendService } from '@app/shared/services/backend.service';
import Swal from 'sweetalert2';
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: 'notiz-kanton-edit',
  templateUrl: './meldung-notiz-kanton-edit.component.html',
  imports: [
    FormsModule,
    TranslatePipe,
  ]
})
export class MeldungNotizKantonEditComponent {
  private readonly backendService = inject(BackendService);

  private id?: number;
  protected readonly notizKanton = signal('');

  readonly result = output<Meldung>();

  @Input()
  set notiz(value: Notiz | undefined) {
    this.id = value?.id;
    this.notizKanton.set(value?.notizKanton ?? '');
  }

  protected save(): void {
    if (!this.id) {
      throw new Error('Target not set');
    }
    const notiz: NotizKantonCmd = {
      id            : this.id,
      notizKanton   : this.notizKanton()
    };

    this.backendService.saveNotizKanton(notiz)
      .subscribe((meldung) => {
        Swal.close();
        this.result.emit(meldung);
      });
  }

  protected delete(): void {
    if (!this.id) {
      throw new Error("Target not set");
    }
    const notiz: NotizKantonCmd = {
      id            : this.id,
      notizKanton   : null
    };

    this.backendService.saveNotizKanton(notiz)
      .subscribe((meldung) => {
        Swal.close();
        this.result.emit(meldung);
      });
  }
}
